export default __webpack_public_path__ + "static/media/loginBackground1.890e3d76.jpg";